import {
  UliContactInformation,
  UliDriverInformation,
  UliInformationExtended,
  UliTruckInformation,
} from '../../uli/models';
import { AllocationViewAllocateType } from '../../constants';
import { LocalDateRangeModel } from '../../../../../models';
import { DockBrief } from '../../../../administration/dock/models/dock.model';
import { AllocationViewTimeslot, AllocationViewTimeslotOutputModel } from '../allocation-view-timeslot.model';
import { AllocateActionRequestModel, AllocationDetailsModel } from './allocation-details.model';

export interface AllocationUliDocksResponse {
  docks: DockBrief[];
  timezone: string;
}

export class AllocationByRuleActionRequestModel {
  compartmentId: number;
  ruleId: number;
  slotId: string;
  details: AllocationDetailsModel;

  constructor(params: AllocationByRuleActionRequestModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class CreateAndAllocateUliRequestModel {
  createUliView: CreateUliViewRequestModel;
  allocateView: AllocateViewRequestModel;
  strategy: UliCreationStrategyEnum = UliCreationStrategyEnum.Default;

  constructor(params: AllocationByRuleActionRequestModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocateViewRequestModel {
  allocationType: AllocationViewAllocateType;
  hubId: number;
  compartmentId: number;
  ruleId?: number;
  slot?: {
    slotId?: number;
    dockId: number;
    dockName?: string;
    timeSlot: LocalDateRangeModel;
    durationInMins?: number;
  };

  constructor(params: AllocateViewRequestModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class CreateUliViewRequestModel {
  uliInformation: UliInformationExtended;
  truckInformation: UliTruckInformation;
  contactData: UliContactInformation;
  driverInformation: UliDriverInformation;

  constructor(params: CreateUliViewRequestModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationManualActionRequestModel {
  compartmentId: number;
  slot: AllocationViewTimeslotOutputModel;
  details: AllocationDetailsModel;

  constructor(slot: AllocationViewTimeslot, details: AllocateActionRequestModel, timezone: string) {
    this.compartmentId = details.compartmentId; // TODO: remove after BE is ready
    this.slot = new AllocationViewTimeslotOutputModel(slot, timezone);
    this.details = details.details;
  }
}

export interface AllocationResponseModel {
  dockId: number;
  dockName: string;
  durationInMins: number;
  slotId: number;
  timeSlot: LocalDateRangeModel;
}

export enum UliCreationStrategyEnum {
  Default = 'DEFAULT',
  CalendarBased = 'CALENDAR_BASED',
}
